import Vue from "vue";
import Router from "vue-router";

import Store from '@/config/store';

import NotFound from '../views/NotFound'

import SampleRoute from '@/modules/echantillon/route.js'
import AuthRoute from '@/modules/authentification/route.js'
import HomeRoute from '@/modules/defaut/route.js'
import ProductRoute from '@/modules/produit/route.js'
import CustomerRoute from '@/modules/client/route.js'
import CompanyRoute from '@/modules/societe/route.js'
import SearchRoute from '@/modules/recherche/route.js'
import OrderRoute from '@/modules/commande/route.js'
import FavoriteRoute from '@/modules/favoris/route.js'
import SoumissionRoute from '@/modules/soumission/route.js'
import EncourRoute from '@/modules/encour/route.js'
import StockRoute from '@/modules/stock/route.js'
import DocRoute from '@/modules/documentation/route.js'
import InvoiceRoute from '@/modules/facture/route.js'
import RateRoute from '@/modules/tarif/route.js'
import CartRoute from '@/modules/panier/route.js'
import AccountRoute from '@/modules/utilisateur/route.js'

import { Bus } from '@/common/Bus';

Vue.use(Router);

const baseRoutes = [
  {
    path: '/page-introuvable',
    name: 'nofound',
    component: NotFound,
    meta: {
      auth: true
    }
  }
];
const routes = baseRoutes.concat(
  SampleRoute,
  AuthRoute, 
  HomeRoute, 
  ProductRoute, 
  CustomerRoute, 
  CompanyRoute,
  SearchRoute,
  OrderRoute,
  FavoriteRoute,
  SoumissionRoute,
  EncourRoute,
  StockRoute,
  DocRoute,
  InvoiceRoute,
  RateRoute,
  CartRoute,
  AccountRoute
);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  if(JSON.parse(localStorage.getItem('company')) !== null) {

    let role = JSON.parse(localStorage.getItem('company')).PTUSER;

    if(to.meta.role.includes(role) === false) {
      router.push("/");
    }
  }

  Bus.$emit('sidemenuclose');
  Bus.$emit('overlay');

  const token = localStorage.getItem("satabapp-token");

  //Si la destination est différente de '/login' et que là d'où je viens est différent de login
  if (to.fullPath !== "/login" && to.path !== '/reset-password') {

    if (token === null || token === '') {
      router.push("/login");
    } else {

      let company = Store.getters['application/get_application_company']

      if((company === null || company === '') && to.fullPath !== "/liste-societe") {
        next("/liste-societe");
      }
    }
  } else if (to.fullPath === '/login') {
    
    if (token !== null && token !== '') {
      router.push("/");
    } else {
        next()
      }
  }  

  let sMetaTitle = 'Satab'

  if(to.meta.title !== undefined) {
    sMetaTitle = 'Satab - '+to.meta.title
  }

  document.title = sMetaTitle

  next()
  
});

export default router;
